
 export class Encryption {

    decrypt(string) {
        return atob(string);
    }// decrypt


    encrypt(string) {
        return btoa(string);
    }// encrypt


}